<template>
    <div class="welcome">
        <!-- TODO: Update for privileged admins -->
        <div class="welcome__greeting">
            <h1>Welcome to the goTenna Pro Management Portal</h1>
            <p class="copy">
                This is your all-in-one dashboard for managing organizations, users, and devices across the platform.
            </p>

            <router-link
                tag="button"
                :to="`/onboarding/privileged/${token}/set-password`"
                class="btn btn-primary"
                data-test-id="privileged-onboarding-continue-button"
            >
                Continue <span class="icon-arrow-right"></span>
            </router-link>
        </div>

        <img
            src="/images/pro-device.png"
            alt="goTenna Pro"
            class="welcome__decorator"
        />
    </div>
</template>

<script>
export default {
    props: ['token'],

    mounted() {
        this.$emit('step', 1)
    },
}
</script>
